export const uniq = <T>(arr: T[]) => [...new Set(arr)];
